import {KEYS} from '../constants/keysStorage'

export const guardarMensajeDeSesion = (mensaje?: unknown) => {
  const texto = `${mensaje ?? ''}`.trim()

  if (texto === '' || texto === 'undefined' || texto === 'null') {
    localStorage.removeItem(KEYS.MESSAGE_SESSION_ERROR)
    return
  }

  localStorage.setItem(KEYS.MESSAGE_SESSION_ERROR, texto)
}
